export interface SharedFolderContact {
    id?: number;
    folder_id?: number;
    first_name?: string;
    last_name?: string;
    profile_image?: string;
    mobile?: string;
    landline?: string | null;
    email?: string;
    address?: string | null;
    city?: string | null;
    post_code?: string | null;
    role_name?: string | null;
    by?: string;
}

// to single object maping
export const mapSharedFolderContact = (data:any): SharedFolderContact => {
    if(!data){
        throw new Error('Invalid Data')
    }
    const  res: SharedFolderContact ={
        id: data.id,
        folder_id: data.folder_id,
        first_name: data.first_name,
        last_name: data.last_name,
        profile_image: data.profile_image,
        mobile: data.mobile,
        landline: data.landline,
        email: data.email,
        address: data.address,
        city: data.city,
        post_code: data.post_code,
        role_name: data.role_name,
        by: data.by,
    }
    return res;
}

// maping list objects
export const mapSharedFolderContacts = (data:any[]): SharedFolderContact[] => {
     if (!Array.isArray(data)) {
       throw new Error('Invalid Data');
     }
     return data.map(mapSharedFolderContact);
}
